export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13421.cf5e67a7.jpg";